import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/groups/id/page';

export const Route = createFileRoute('/_app/settings/groups/$id/')({
  component: Page,
});
